<section class="dialog-container">
    <h5>
        {{ data.title }}
    </h5>
    <p>{{ data.message }}</p>
    <div class="dialog-actions">
        <save-btn (click)="handleSubmit()" [label]="'CONFIRM'"></save-btn>
        <cancel-btn (click)="handleCancel()" />
    </div>
</section>
